export default "__VITE_ASSET__BBoOFsCm__";